
import './assets/css/App.css';
import Body from './components/Body';
import InicioBanner from './components/InicioBanner';


function App() {
  return (
    <div>
      <InicioBanner />
      <Body />
      
    </div>
  );
}

export default App;
